'use strict';

import {JOWITUserRoles, SiPHUserRoles} from 'helpers/interfaces';

export class AccessHelper {
  static priviledgeCachedToken: string = null;
  static menuCachedToken: string = null;
  static priviledgeScopes: string = "";
  static menuScopes: string = "";
  static specificPermissions = ['-read', '-modify', '-calculate', '-import-excel', '-export-excel'];
  static userInformation: any;

  static hasAllPermissionFromBaseScope(permissions: string) {
    let baseScopes = this.removeSpecificFeatures(permissions);
    let flag = true;

    // Below used to prevent scope data corrupt
    //
    /*for (let specificPermission of this.specificPermissions) {
      console.log(baseScopes, specificPermission, this.hasPermission(baseScopes, specificPermission));
      if (this.hasPermission(baseScopes, specificPermission)) flag = false;
    }*/

    return flag && this.hasPermission(baseScopes, null);
  }

  static hasReadingPermission(permissions: string) {
    let baseScopes = this.removeSpecificFeatures(permissions);

    return this.hasPermission(baseScopes, null) || this.hasPermission(baseScopes, '-read');
  }

  static hasModifyingPermission(permissions: string) {
    let baseScopes = this.removeSpecificFeatures(permissions);

    return this.hasPermission(baseScopes, null) || this.hasPermission(baseScopes, '-modify');
  }

  static hasSpecificFeatures(permissions: string) {
    permissions = this.cleanPermissionString(permissions);

    return this.removeSpecificFeatures(permissions) != permissions;
  }

  static removeSpecificFeatures(permissions: string) {
    permissions = this.cleanPermissionString(permissions);

    let baseScopes = permissions;

    for (let specificPermission of this.specificPermissions) {
      baseScopes = baseScopes.split(specificPermission).join('');
    }

    return baseScopes;
  }

  static cleanPermissionString(permissions) {
    return permissions || "";
  }

  static hasPermission(permissions: string, extension: string) {
    this.userInformation = JSON.parse(localStorage.getItem('userInfo'));
    let token = JSON.parse(localStorage.getItem('token'));
    permissions = this.cleanPermissionString(permissions);

    if (permissions == '') return true;
    extension = extension || '';

    if (this.userInformation.roles && this.userInformation.roles != this.priviledgeCachedToken) {
      this.priviledgeCachedToken = this.userInformation.roles;
      this.priviledgeScopes = ' ' + this.userInformation.roles.join(' ') + ' ';
    }

    if (this.priviledgeScopes.indexOf(' ROLE_ADMIN_PARKING ') != -1 || this.priviledgeScopes.indexOf(' ROLE_SASIN_ADMIN ') != -1 || this.priviledgeScopes.indexOf(' ROLE_ADMIN_BLUE_PARKING ') != -1) return true;

    let list = permissions.split(' ');
    for (let permission of list) {
      if (token.scope.indexOf(' ' + permission + extension + ' ') != -1) return true;
    }

    return false;
  }

  static hasMenuAccessPermission(permissions: string) {
    this.userInformation = JSON.parse(localStorage.getItem('userInfo'));
    permissions = this.cleanPermissionString(permissions);

    if (permissions == '') return true;

    if (this.userInformation.menus && this.userInformation.menus != this.menuCachedToken) {
      this.menuCachedToken = this.userInformation.menus;
      this.menuScopes = ' ' + this.userInformation.menus.join(' ') + ' ';
    }

    let list = permissions.split(' ');
    for (let permission of list) {
      if (this.menuScopes.indexOf(' ' + permission + ' ') != -1) return true;
    }

    return false;
  }

  static hasAccessParkingMenu() {
    const permissions = [
      'PARKING_READ_MEMBER', 
      '1MOVE_PARKING_MEMBER_READ', 
      '1MOVE_PARKING_PACKAGE_READ', 
      'PARKING_VIRTUAL_CARD_READ', 
      'PARKING_READ_SUBSCRIBER', 
      'PARKING_EDIT_SPACE', 
      'PARKING_READ_SPACE', 
      'PARKING_PRICE', 
      'PARKING_BOOKING'
    ];

    return this.hasMenuAccessPermission(permissions.join(' '));
  }

  static hasAccessPromotionMenu() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo'));
    let menus = userInfo.menus.filter((menu: string) => menu.includes('PROMOTION'));
    return Array.isArray(menus) && (menus.length > 0);
  }

  static hasMenuAccessPermissionBySiPHRole(role: string): boolean {
    this.userInformation = JSON.parse(localStorage.getItem('userInfo'));
    const roles = this.userInformation.roles;
    const isSiPHUserRole = roles.includes(SiPHUserRoles[role])
    const isSiPhSuperAdmin = roles.includes(SiPHUserRoles.ROLE_SIPH_SUPERADMIN)
    return isSiPhSuperAdmin || isSiPHUserRole;
  }

  static hasNotMenuAccessPermissionBySiPHRole(role: string): boolean {
    this.userInformation = JSON.parse(localStorage.getItem('userInfo'));
    return !this.userInformation.roles.includes(SiPHUserRoles[role]);
  }

  static isJOWITAdmin(role: string = JOWITUserRoles.ROLE_JOWIT_ADMIN_ORGANIZATION): boolean {
    this.userInformation = JSON.parse(localStorage.getItem('userInfo'));
    return this.userInformation.roles.includes(JOWITUserRoles[role]);
  }
}



// WEBPACK FOOTER //
// ./src/app/helpers/access.helper.ts